import React, { useState } from 'react'
import { NavLink, useRouteMatch } from 'react-router-dom'
import Popover from '@material-ui/core/Popover'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import CheckOutlinedIcon from 'components/material-symbol/icons/Check'
import IconButton from '@material-ui/core/IconButton'
import AppsIcon from 'components/material-symbol/icons/Apps'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import clsx from 'clsx'
import brandOptions from './brand-options'

const drawerWidth = 250

const useStyles = makeStyles(theme => ({
  brandSwitcherContainer: {
    display: 'flex',
    width: `${drawerWidth - 24 - 11}px`, // 24 for left padding, 11 for ?
    alignItems: 'center',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    },
  },
  brandSwitcherContainerStart: {
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'flex-start',
    },
  },
  listItemText: {
    '& > span': {
      fontWeight: 500,
    },
  },
}))

const BrandListItem = ({ logo, path, external, label }) => {
  const classes = useStyles()
  const { path: routeMatch } = useRouteMatch()
  const selected = path === routeMatch
  const linkProps = !external
    ? { component: NavLink, to: path }
    : { component: 'a', href: path, target: external.target || '_blank' }

  return (
    <ListItem button {...linkProps}>
      <ListItemIcon>{logo}</ListItemIcon>
      <ListItemText primary={label} className={classes.listItemText} />
      {selected && (
        <ListItemSecondaryAction>
          <CheckOutlinedIcon />
        </ListItemSecondaryAction>
      )}
    </ListItem>
  )
}

const BrandSwitcher = ({ logo, alignStartOnMobile = false }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const classes = useStyles()
  const handleOpen = e => setAnchorEl(e.currentTarget)
  const handleClose = () => setAnchorEl(null)

  return (
    <>
      <div
        className={clsx(classes.brandSwitcherContainer, {
          [classes.brandSwitcherContainerStart]: alignStartOnMobile,
        })}
      >
        <IconButton
          aria-controls="brand-switcher-menu"
          aria-haspopup="true"
          aria-label="expand"
          onClick={handleOpen}
          edge={alignStartOnMobile && isMobile ? 'start' : false}
        >
          <AppsIcon color="secondary" />
        </IconButton>
        <img
          src={logo.src}
          alt={logo.alt}
          style={{
            display: 'block',
            width:
              (isMobile ? logo.mobileWidth ?? logo.width : logo.width) ??
              '110px',
            height:
              (isMobile ? logo.mobileHeight ?? logo.height : logo.height) ??
              'auto',
          }}
        />
      </div>
      <Popover
        id="brand-switcher-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <List style={{ width: drawerWidth, padding: 0 }}>
          {brandOptions.map(brand => (
            <BrandListItem key={brand.label} {...brand} />
          ))}
        </List>
      </Popover>
    </>
  )
}

export default BrandSwitcher
